import * as React from 'react';
import { Typography } from '@mui/material';

export const Footer: React.FC<{ text: string }> = (props) => (
    <div style={{ height: '50px' }}>
        <footer
            style={{
                position: 'absolute',
                left: 0,
                bottom: 0,
                width: '100%',
                textAlign: 'center',
                margin: '25px',
            }}
        >
            <Typography variant="subtitle2">{props.text}</Typography>
        </footer>
    </div>
);
